var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rounded-md",class:[_vm.width, _vm.height, _vm.color, _vm.colorDark]})}
var staticRenderFns = []

export { render, staticRenderFns }